import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, BUSINESS } = authRoles

const Collaborations = () =>
  import(/* webpackChunkName: "collaborations-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/collaborations',
    name: 'collaborations',
    component: Collaborations,
    meta: {
      title: 'Collaborations',
      auth: {
        roles: [ADMIN, BUSINESS],
        redirect: '/auth/login',
        forbiddenRedirect: '/403',
      },
    },
  },
]
